// import Pattern from './Pattern';

export default {
  // component: Pattern,
  priority: 97,
  path: 'pattern',
  permissions: ['RequestsMenu/RequestPattern/'] , //['PatternDefinitionMenu', 'PatternAssignmentMenu'],
  name: app.translate('routes.home.requests.Pattern'),
  icon: 'lock-pattern',
  drawer: true,
};


